import * as yup from "yup";
import { t } from "i18next";

export const getChangeOldPasswordSchema = () =>
  yup.object().shape({
    oldPassword: yup.string().required(t("validation.required")),
    newPassword: yup
      .string()
      .required(t("validation.required"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?"-:{}|<>]).{8,}$/,
        t("validation.passwordContain"),
      ),
    confirmPassword: yup
      .string()
      .required(t("validation.required"))
      .oneOf([yup.ref("newPassword")], t("validation.passwordMustMatch")),
  });
